<template>
  <footer id="footer">
    <div class="inner">
      <div class="left-container">
        <button type="button" class="f-menu" @click="getPolicyModal">{{ $t('sdl.privacyPolicy.policy') }}</button>
        <span class="f-copy">Copyright 2024 SAMSUNG. All rights reserved.</span>
      </div>
      <div class="right-container"><span class="f-logo"></span></div>
    </div>
  </footer>
</template>

<script>
import { SDLUtil } from '@/utils';
import SDLLocale from '@/mixin/SDLLocale';
import PolicyPopup from '@/components/common/popup/PolicyPopup.vue';

export default {
  mixins: [SDLLocale],
  data() {
    return {
      ppList: [],
    };
  },
  methods: {
    getPolicyModal() {
      SDLUtil.show(
        PolicyPopup,
        {},
        {
          width: '980px',
          height: 'auto',
        },
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/view/admin/main/GcrmFooter.vue